/**
 * Desktop (1201px+): collapse announcement bar on scroll down, show on scroll up.
 * Runs after DOM ready so #header-group and .announcement-bar are present.
 */
(function () {
  function scrollY() {
    return window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
  }

  function init() {
    var headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;
    if (!headerGroup.querySelector('.announcement-bar')) return;
    var sectionEl = headerGroup.querySelector('[data-announcement-bar-section]');
    if (!sectionEl) {
      var first = headerGroup.firstElementChild;
      if (first && first.querySelector('.announcement-bar')) first.setAttribute('data-announcement-bar-section', '');
    }

    var lastScrollY = scrollY();
    var ticking = false;
    var scrollThreshold = 20;
    var minDeltaDown = 12;
    var minDeltaUp = 8;
    var showLockUntil = 0;

    function updateCollapsed() {
      if (!window.matchMedia || !window.matchMedia('(min-width: 1201px)').matches) {
        headerGroup.removeAttribute('data-announcement-bar-collapsed');
        lastScrollY = scrollY();
        ticking = false;
        return;
      }
      var currentScrollY = scrollY();
      if (currentScrollY <= scrollThreshold) {
        headerGroup.removeAttribute('data-announcement-bar-collapsed');
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }
      var delta = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;
      if (delta > minDeltaDown) {
        if (Date.now() >= showLockUntil) {
          headerGroup.setAttribute('data-announcement-bar-collapsed', 'true');
        }
      } else if (delta < -minDeltaUp) {
        headerGroup.removeAttribute('data-announcement-bar-collapsed');
        showLockUntil = Date.now() + 450;
      }
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateCollapsed);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    var mql = window.matchMedia('(min-width: 1201px)');
    if (mql.addEventListener) {
      mql.addEventListener('change', function () {
        if (!mql.matches) headerGroup.removeAttribute('data-announcement-bar-collapsed');
      });
    }
    updateCollapsed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
